import { Box } from '@factorialco/deprecated-design-system'
import { DataSchemaItemFragment } from 'generated/resources/graphql'

import MoneyField from 'modules/core/components/MoneyField'

import { WizardData } from 'modules/employees/components/UnifiedAddEmployeeModal/types'
import { getStringFieldValue } from 'modules/employees/components/UnifiedAddEmployeeModal/utils'
import { Salary } from 'modules/job_catalog/lib/salary'
import { getRecommendedSalaryValue, isValidSalaryValue } from 'modules/job_catalog/lib/salaryUtils'

import { EnumField } from './EnumField'
import MatchingValueTooltip from './MatchingValueTooltip'

interface Props {
  label: string
  fieldName: keyof WizardData
  frequencyFieldName: keyof WizardData
  groupFields: DataSchemaItemFragment[]
  data: WizardData
  referenceSalary: Salary | undefined
  onChange?: (value: string, frequency?: string) => void
  error?: string
}

export const CheckedMoneyField = ({
  label,
  fieldName,
  frequencyFieldName,
  groupFields,
  data,
  referenceSalary,
  onChange,
  error,
}: Props) => {
  const isSalaryField = fieldName === 'salaryAmount'

  const handleNotLinkedClick = () => {
    if (!referenceSalary || !onChange) return
    const suggestedSalary = getRecommendedSalaryValue(referenceSalary)
    const newSalaryAmount = suggestedSalary ? `${suggestedSalary}` : ''

    onChange(newSalaryAmount, referenceSalary.periodicity)
  }

  const onChangeFrequency = (name: string, value: string) => {
    onChange?.(data.salaryAmount || '', value)
  }
  const frequencyField = groupFields.find(
    (field) => field.fieldName === 'contracts_salary_frequency'
  )

  const isValidSalary =
    referenceSalary &&
    isValidSalaryValue(
      referenceSalary,
      Number(data[fieldName]),
      data.contractsSalaryFrequency || ''
    )

  /**
   * TODO: This is a temporary solution to display the currency symbol without line breaks. After the migration to f0 components, it must be removed.
   */
  const currencySymbol = (
    <Box
      style={{
        whiteSpace: 'nowrap',
      }}
    >
      {data?.legalEntity?.currency || referenceSalary?.currency || '-'}
    </Box>
  )

  return (
    <Box flexDirection="row" width="full" alignItems="center" gap="s8" position="relative">
      <MoneyField
        label={label}
        onChange={onChange}
        // @ts-expect-error: currencySymbol is a React node
        currency={currencySymbol}
        value={data[fieldName] ? `${data[fieldName]}` : undefined}
        error={error}
      />
      <EnumField
        key="contractsSalaryFrequency"
        dataSchemaItem={frequencyField}
        value={getStringFieldValue(frequencyFieldName, data) || ''}
        onChange={onChangeFrequency}
        mandatory={frequencyField?.required}
        legalEntityId={!!data?.legalEntityId ? +data.legalEntityId : undefined}
        country={data.legalEntityCountry}
        error={error}
      />
      {isSalaryField && referenceSalary && (
        <Box style={{ marginTop: '24px' }}>
          <MatchingValueTooltip
            type="salary"
            linked={!!isValidSalary}
            onClick={handleNotLinkedClick}
          />
        </Box>
      )}
    </Box>
  )
}
